// import { RootStore } from 'mobx-stores/root-store'
import { UserDTO } from 'models'
import { getUserFullName } from '../users-main-store'
import { EntitySearchBase } from 'mobx-stores/utils'

export class UserSearchStore extends EntitySearchBase<UserDTO> {
  private rootStore: any

  constructor (rootStore: any) {
    super()
    this.rootStore = rootStore
  }

  public onComponentMount = (): void => {
    this.setArguments({
      loadEntities: this.rootStore.usersMainStore.loadUsers,
      onEntityActionButtonClick: this.rootStore.viewStorePageStore
        .onAddUserClick,
      searchedPropertySelector: getUserFullName,
      resultNameSelector: getUserFullName
    })
  }

  public get entitiesList (): UserDTO[] {
    return this.rootStore.usersMainStore.usersList
  }
}
